import React from 'react';
import svgIcon from 'components/hoc/svgIcon';

const svg = () => (
  <svg viewBox="0 0 26 20">
    <path d="M8.522.122A.998.998 0 019.543.16l6.071 3.93a1.001 1.001 0 01-1.087 1.68L10 2.84V17c0 2.758-2.243 5-5 5s-5-2.242-5-5c0-2.756 2.243-5 5-5 1.13 0 2.162.392 3 1.026V1c0-.366.2-.703.522-.88zM25 18a1 1 0 110 2H15a1 1 0 110-2h10zM5 14c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm20 0a1 1 0 110 2H15a1 1 0 110-2h10zm0-4a1 1 0 110 2H15a1 1 0 110-2h10z" />
  </svg>
);
export default svgIcon(svg);
